<template>
    <p><slot/></p>
</template>

<script>
export default {
name: "PrivacyModal_Text"
}
</script>
